import * as form from '../form';

export const legalAssociationsInternationalAndDomesticTerrorismEngagement = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        Why: form.textarea(xitem.Why),
        When: form.daterange(xitem.When),
        What: form.textarea(xitem.What),
      },
    };
  });
  return {
    HasInternationalAndDomesticTerrorismEngagement: form.branch(data.HasInternationalAndDomesticTerrorismEngagement),
    List: form.collection(items, (data.List || {}).branch),
  };
};
